import React from "react";
import { createUseStyles } from "react-jss";
import { BulkCheckbox, BulkRadioButtons, } from "../../forms/formGrid/FormGridComponents";
import { FormGridColumnTypes } from "../../types/FormGrids";
import { classNames } from "../../utils/classNames";
import { V2TableCell } from "./TableCell";
import { useTableFormClasses } from "./TableForm";
import { V2TableRowComponent } from "./TableRow";
import { useTableContext } from "../../hooks/useTableContext";
import { THEME } from "../../theming/theming";
export function TableBulkAction(props) {
    const { gridClassName } = useTableContext();
    const { cellForm } = useTableFormClasses();
    const classes = useTableBulkActionClasses();
    const cellClasses = useClasses();
    const { form, dataId, dataTestId } = props;
    if (!form)
        return null;
    return (React.createElement(V2TableRowComponent, { item: form?.values, rowIndex: 0, ...props, gridClassName: classNames(gridClassName, classes.bulkAction) }, form?.name &&
        props?.headings?.map((heading, cellIndex) => {
            const cellDataId = dataId && `${dataId}-bulkAction`;
            const cellDataTestId = dataTestId && `${dataTestId}-bulkAction`;
            if (cellIndex === 0 && form.bulkActionLabel) {
                return (React.createElement(V2TableCell, { ...props, colIndex: cellIndex + 1, heading: heading, className: cellForm, key: cellIndex, dataId: cellDataId && `${cellDataId}-label`, dataTestId: cellDataTestId && `${cellDataTestId}-label` },
                    React.createElement("span", { className: "font-weight-bold" }, form.bulkActionLabel)));
            }
            if (!heading.formComponent?.bulkAction) {
                return (React.createElement(V2TableCell, { ...props, colIndex: cellIndex + 1, heading: heading, className: cellForm, key: cellIndex, dataId: cellDataId && `${cellDataId}-null`, dataTestId: cellDataTestId && `${cellDataTestId}-null` }));
            }
            return (React.createElement(V2TableCell, { ...props, colIndex: cellIndex + 1, heading: heading, className: classNames(typeof heading.formComponent.bulkAction == "string"
                    ? cellClasses.label
                    : "", cellForm), key: cellIndex, dataId: cellDataId && `${cellDataId}-${cellIndex}`, dataTestId: cellDataTestId && `${cellDataTestId}-${cellIndex}` },
                heading.formComponent?.type === FormGridColumnTypes.Radio && (React.createElement(BulkRadioButtons, { label: typeof heading.formComponent.bulkAction == "string"
                        ? heading.formComponent.bulkAction
                        : undefined, name: form?.name, formComponent: heading.formComponent })),
                heading.formComponent?.type === FormGridColumnTypes.Checkbox && (React.createElement(BulkCheckbox, { label: typeof heading.formComponent.bulkAction == "string"
                        ? heading.formComponent.bulkAction
                        : undefined, name: form.name, formComponent: heading.formComponent, dataId: cellDataId && `${cellDataId}-${cellIndex}`, dataTestId: cellDataTestId && `${cellDataTestId}-${cellIndex}` }))));
        })));
}
export const useClasses = () => {
    const useStyles = createUseStyles({
        label: {
            marginTop: 4,
        },
    });
    return useStyles();
};
export const useTableBulkActionClasses = () => {
    const useStyles = createUseStyles({
        bulkAction: {
            backgroundColor: THEME.palette.gray.smoke.color,
        },
    });
    return useStyles();
};
